export enum TimeConvention {
  HOUR_12 = "hour12",
  HOUR_24 = "hour24",
}

export enum Products {
  STATIONS = "stations",
  ROUTING = "routing",
  RANGE = "range",
}

export enum Addons {
  SETTINGS = "settings",
  CLIMATE_REPORTING = "climateReporting",
  SEARCH = "search",
}

export enum SearchProvider {
  GOOGLE = "google",
  HERE = "here",
  TOMTOM = "tomtom",
  GEOAPIFY = "geoapify",
}

export enum StationDatabaseProvider {
  ECOMOVEMENT = "ecomovement",
  CARIAD = "cariad",
  DEFTPOWER = "deftpower",
  DRIIVZ = "driivz",
}

export type MeasurementSystem = "metric" | "imperial";
export type DrivingMode = "comfort" | "normal" | "sport";
export type Elevation = "elevation";
export type Consumption = "consumption";
